var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.666 0.166656H2.33268C1.89065 0.166656 1.46673 0.342251 1.15417 0.654812C0.84161 0.967372 0.666016 1.3913 0.666016 1.83332V20.1667C0.666016 20.6087 0.84161 21.0326 1.15417 21.3452C1.46673 21.6577 1.89065 21.8333 2.33268 21.8333H25.666C26.108 21.8333 26.532 21.6577 26.8445 21.3452C27.1571 21.0326 27.3327 20.6087 27.3327 20.1667V1.83332C27.3327 1.3913 27.1571 0.967372 26.8445 0.654812C26.532 0.342251 26.108 0.166656 25.666 0.166656ZM17.7993 17.6167L11.8827 8.79999L6.59935 16.5333L2.84935 13.2L3.99935 11.875L6.24935 13.8667L11.8827 5.63332L17.8743 14.5583L23.7077 6.83332L25.1243 7.89999L17.7993 17.6167Z",
    fill: "#FF8A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.19c3ac5f.svg";
export { ForwardRef as ReactComponent };